import { NgModule } from "@angular/core";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { IboxtoolsComponent } from "./iboxtools.component";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        BsDropdownModule.forRoot(),
        IboxtoolsComponent,
    ],
    exports: [IboxtoolsComponent],
})

export class IboxtoolsModule { }
